import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProgramProjectsListComponent } from './program-projects-list.component';

const routes: Routes = [
  {
    path: '',
    component: ProgramProjectsListComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProgramProjectsListRoutingModule { }
